import PanelCardHeader from "../../components/layout/panel/PanelCardHeader";
import PanelCard from "../../components/layout/panel/PanelCard";
import { useUpdatePassword } from "../../api/query_hooks";
import { Button, CardBody, Form } from "react-bootstrap";
import Panel from "../../components/layout/panel/Panel";
import { useState } from "react";
import 'boxicons';

const AccountSecurity = ({user, addresses}) => {

    return (
        <Panel className="py-5 ps-0 pe-md-3">
            <PasswordCard addresses={addresses} />
            <MultiFactorCard user={user} />
        </Panel>
    );
}

const PasswordCard = ({}) => {

    const [repeatPassword, setRepeatPassword] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const mutation = useUpdatePassword();

    const updatePassword = (e) => {
        e.preventDefault();
        setError("");

        if(password !== repeatPassword) {
            setError("The passwords don't match");
            return;
        }

        mutation.mutate({password});
        setEditMode(false);
    }


    return (
        <PanelCard>
            <PanelCardHeader>
                <span>Password</span>
                {!editMode &&
                    <Button variant="link" className="p-0 m-0" onClick={() => setEditMode(true)} aria-describedby="open password update form">
                        <box-icon color='white' name='refresh'></box-icon>
                    </Button>
                } {
                    editMode &&
                    <Button variant="link" className="p-0 m-0" onClick={() => setEditMode(false)} aria-describedby="close password update form">
                        <box-icon color='white' name='x' type='solid' ></box-icon>
                    </Button>
                }
            </PanelCardHeader>
            {editMode &&
                <Form className="position-relative col-12 px-3 py-2 pt-4 px-lg-4 d-flex flex-column justify-content-center align-items-center" onSubmit={updatePassword}>
                    <div className="col-12 d-flex flex-column flex-lg-row gap-lg-4 justify-content-center">
                        <Form.Group className="mb-3 d-flex flex-column col-lg-5" controlId="passwordBox" >
                            <Form.Label className="text-white-50">New password</Form.Label>
                            <Form.Control size="sm" className="bg-darker rounded-0" type="password" placeholder="********" onChange={e => setPassword(e.target.value)} aria-describedby="new passwords" />
                        </Form.Group>

                        <Form.Group className="mb-3 d-flex flex-column col-lg-5" controlId="repeatPasswordBox" >
                            <Form.Label className="text-white-50">Repeat password</Form.Label>
                            <Form.Control size="sm" className="bg-darker rounded-0" type="password" placeholder="********" onChange={e => setRepeatPassword(e.target.value)} aria-describedby="repeat new password" />
                        </Form.Group>
                    </div>

                    <Button variant="warning" size="sm" className="my-3 px-4 px-lg-3" type="submit" aria-describedby="save">Submit</Button>

                    <span className="text-danger">{mutation.isError && mutation.error.response?.data}</span>
                    <span className="text-danger">{error}</span>
                </Form>
            }
            {!editMode &&
                <CardBody className="ps-4 py-4">
                    <span className="text-white-50 user-select-none">Click the button on the top-right to update your passowrd.</span>
                </CardBody>
            }
        </PanelCard>
    );
}

const MultiFactorCard = () => {

    return (
        <PanelCard header={"Multi-Factor Auth"} >
            <CardBody className="ps-4 py-4 text-white-50 user-select-none">Multi-Factor authentication is not available yet.</CardBody>
        </PanelCard>
    );
}


export default AccountSecurity;